import COORXY from '../COORXY';
export function bd09togcj02(bdlng1, bdlat1) {
    var coorxy = new COORXY();
    var xPI = 3.14159265358979324 * 3000.0 / 180.0;
    var bdlng = +bdlng1;
    var bdlat = +bdlat1;
    var x = bdlng - 0.0065;
    var y = bdlat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPI);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPI);
    var gglng = z * Math.cos(theta);
    var gglat = z * Math.sin(theta);
    coorxy.X = gglng;
    coorxy.Y = gglat;
    return coorxy;
}
export function gcj02tobd09(lng1, lat1) {
    var coorxy = new COORXY();
    var xPI = 3.14159265358979324 * 3000.0 / 180.0;
    var lat = +lat1;
    var lng = +lng1;
    var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * xPI);
    var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * xPI);
    var bdlng = z * Math.cos(theta) + 0.0065;
    var bdlat = z * Math.sin(theta) + 0.006;
    coorxy.X = bdlng;
    coorxy.Y = bdlat;
    return coorxy;
}
export function wgs84togcj02(lng1, lat1) {
    var coorxy = new COORXY();
    var PI = 3.1415926535897932384626;
    var a = 6378245.0;
    var ee = 0.00669342162296594323;
    var lat = +lat1;
    var lng = +lng1;
    if (out_of_china(lng, lat)) {
        coorxy.X = lng;
        coorxy.Y = lat;
        return coorxy;
    }
    else {
        var dlat = transformlat(lng - 105.0, lat - 35.0);
        var dlng = transformlng(lng - 105.0, lat - 35.0);
        var radlat = lat / 180.0 * PI;
        var magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        var sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        var mglat = lat + dlat;
        var mglng = lng + dlng;
        coorxy.X = mglng;
        coorxy.Y = mglat;
        return coorxy;
    }
}
export function gcj02towgs84(lng1, lat1) {
    var coorxy = new COORXY();
    var PI = 3.1415926535897932384626;
    var a = 6378245.0;
    var ee = 0.00669342162296594323;
    var lat = +lat1;
    var lng = +lng1;
    if (out_of_china(lng, lat)) {
        coorxy.X = lng;
        coorxy.Y = lat;
        return coorxy;
    }
    else {
        var dlat = transformlat(lng - 105.0, lat - 35.0);
        var dlng = transformlng(lng - 105.0, lat - 35.0);
        var radlat = lat / 180.0 * PI;
        var magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        var sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        var mglat = lat + dlat;
        var mglng = lng + dlng;
        coorxy.X = lng * 2 - mglng;
        coorxy.Y = lat * 2 - mglat;
        return coorxy;
    }
}
export function transformlat(lng1, lat1) {
    var PI = 3.1415926535897932384626;
    var lat = +lat1;
    var lng = +lng1;
    var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
    return ret;
}
export function transformlng(lng1, lat1) {
    var PI = 3.1415926535897932384626;
    var lat = +lat1;
    var lng = +lng1;
    var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
    return ret;
}
export function out_of_china(lng1, lat1) {
    var lat = +lat1;
    var lng = +lng1;
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
}
